import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";

import { Draft } from "immer";
import RequestPriceListState, { BrandPriceList, RequestHeaderData } from "../Data/ADIRequestPriceListState";
import { result } from "lodash";

const initialState: RequestPriceListState = {
    isLoading: false,
    brandData: [],
    RequestHeader: {
        customerNumber: "",
        userID: "",
        userEmail: "",
        recordCount: "",
        requestId: "",
        requestVersion: "",
        returnCode: "",
        returnMessage: "",
    },
    brandsSelected:"Specific Brands",
  
};

const reducer = {
    "Common/RequestPriceList": (draft: Draft<RequestPriceListState>, action: { result: BrandPriceList[] | [] }) => {
        draft.brandData = action.result;
    },
    "Common/RequestPriceHeader": (draft: Draft<RequestPriceListState>, action: { result:any; }) => {
        draft.RequestHeader = action.result;
       
        
    },
    "Common/RequestPriceListRadioButton": (draft: Draft<RequestPriceListState>, action: { result: string}) => {
        draft.brandsSelected = action.result;
    },
    
   

     
    
   
};

export default createTypedReducerWithImmer(initialState, reducer);
